// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"3f6ba7ca","150":"9f2dccd0","154":"9b3abfc8","201":"c3cc16de","231":"8760c416","395":"26fd5353","642":"f7e5eee5","858":"a1cfbd5d","904":"8247d192","973":"b3878c64"}[chunkId] + ".chunk.js";
};